import careersConfig from "./careers-config.json";
import { getPositionDetailsByID } from "/server/services/comeet-service/comeet-service";
import { DEFAULT_UNLISTED_POSITION_DATA, UNLISTED_POSITION_ID } from "/constants/careers/careers";
import { isPositionRelevantToType } from "/server/services/comeet-service/position-type-service";

const getDeptIdFromName = (deptComeetName) => {
  const deptInfo = careersConfig.departments.find((d) => d.name === deptComeetName);
  return deptInfo?.id;
};

//HELPER METHOD
const getDeptID = (deptComeetName) => {
  const nameFromConfig = getDeptIdFromName(deptComeetName);
  if (nameFromConfig) return nameFromConfig;

  // Backwards compatibility: (can be deleted soon)

  const name = deptComeetName ? deptComeetName.toLowerCase() : "";
  if (name == "cs" || name.indexOf("client relations") >= 0 || name.indexOf("customer succ") >= 0)
    return "customersucc";
  else if (name.indexOf("marketing") >= 0) return "marketing";
  else if (name.indexOf("hr") >= 0) return "hr";
  else if (name.indexOf("r&d") >= 0) return "rnd";
  else if (name.indexOf("design") >= 0) return "design";
  else if (name.indexOf("product") >= 0) return "product";
  else if (name.indexOf("finance") >= 0) return "finance";
  else if (name.indexOf("consulting") >= 0) return "consulting";
  else if (name.indexOf("partnership") >= 0) return "partnership";
  else if (name.indexOf("business operations") >= 0) return "businessoperations";
  else if (name.indexOf("operation") >= 0) return "operations";
  else if (name.indexOf("sfs") >= 0) return "sfs";
  else if (name.indexOf("communications") >= 0) return "communications";
  else if (name.indexOf("legal") >= 0) return "legal";
  else if (name.indexOf("socialimpact") >= 0) return "socialimpact";
  else if (name.indexOf("unlisted") >= 0) return null;

  //implied else:
  console.error("Failed to match department for", deptComeetName);
  return null;
};

//HELPER METHOD
const getDeptIDFromPosition = (posObj) => {
  //returns dept ID from a Comeet position obj
  const deptID = getDeptID(posObj.department);
  return deptID;
};

//HELPER METHOD
const getDeptInfo = (posObj) => {
  const deptID = getDeptIDFromPosition(posObj);
  if (!deptID) {
    console.error("Failed to getDeptInfo", posObj);
    return;
  }
  const deptInfo = careersConfig.departments.find((d) => d.id === deptID);
  if (!deptInfo) {
    console.error("Failed to find team for ID -", deptID);
    return;
  }
  return deptInfo;
};

//HELPER METHOD
const getLocationID = (locComeetName) => {
  const name = !locComeetName ? "" : locComeetName.toLowerCase();
  if (name.indexOf("london") >= 0) return "london";
  if (name.indexOf("miami") >= 0) return "miami";
  if (name.indexOf("york") >= 0) return "newyork";
  if (name.indexOf("sf") >= 0 || name.indexOf("san franc") >= 0) return "sf";
  if (name.indexOf("sydney") >= 0) return "sydney";
  if (name.indexOf("aviv") >= 0) return "telaviv";
  if (name.indexOf("tokyo") >= 0) return "tokyo";
  if (name.indexOf("chicago") >= 0) return "chicago";
  if (name.indexOf("sao paulo") >= 0) return "saopaulo";
  if (name.indexOf("denver") >= 0) return "denver";
  if (name.indexOf("houston") >= 0) return "houston";
  if (name.indexOf("austin") >= 0) return "austin";
  if (name.indexOf("warsaw") >= 0 ||
      name.indexOf("warsha") >= 0) return "warsaw";
  if (name.indexOf("singapore") >= 0) return "singapore";
  if (name.indexOf("melbourne") >=0) return "melbourne";
  if (
    name.indexOf("remoteus") >= 0 ||
    name.indexOf("remote, us") >= 0 ||
    name.indexOf("remote-us") >= 0 ||
    name.indexOf("remote_us") >= 0 ||
    name.indexOf("remote us") >= 0 ||
    name.indexOf("us remote") >= 0
  )
    return "remote-us";

  //implied else:
  console.error("Failed to match location for", locComeetName);
  return null;
};

//HELPER METHOD
const getLocationInfoFromPosition = (posObj) => {
  const locID = getLocationIDFromPosition(posObj);
  if (!locID) return;
  const locInfo = careersConfig.locations.find((loc) => loc.id == locID);
  if (!locInfo) {
    console.error("Failed to find locInfo for locID -", locID, posObj);
    return;
  }
  return locInfo;
};

const getLocationIDFromPosition = (posObj) => {
  const locID = getLocationID(posObj.location.name);
  return locID;
};

const getPositionData = async (id, positionsType) => {
  let positionData;
  try {
    positionData = await getPositionDetailsByID(id, positionsType);
  } catch (e) {
    if (id === UNLISTED_POSITION_ID) {
      positionData = DEFAULT_UNLISTED_POSITION_DATA;
    } else {
      throw e;
    }
  }
  return positionData;
};

const isPositionIdValid = (positionId) => {
  const pattern = /^[A-F0-9]{2}\.[A-F0-9]{3}$/;
  return pattern.test(positionId);
};

const filterByPositionType = (allPositionsData, positionsType) => {
  return allPositionsData.filter((position) => isPositionRelevantToType(position, positionsType));
};

module.exports = {
  UNLISTED_POSITION_ID,
  getDeptID,
  getDeptIDFromPosition,
  getDeptInfo,
  getLocationID,
  getLocationInfoFromPosition,
  getLocationIDFromPosition,
  getPositionData,
  filterByPositionType,
  isPositionIdValid
};
